export default __webpack_public_path__ + "static/media/Jessica.f3516fc0.jpg";